// test API URL

//export let BaseUrl = 'https://realapis.yottareal.com/';
export let BaseUrl = 'http://localhost/Cybersoft.YottaReal.WebAPIs/';
export let WebApiUrl = BaseUrl;
